import _ from "lodash";

import { formatDate } from "./formatters";

export const stringParser = (value?: string): string | undefined =>
  value ? _.trim(value) : undefined;

export const optionalStringParser = _.identity;

export const phoneParser = (number: string): string =>
  number
    ? number.replace(/\D/g, "").substring(0, 10)
    : optionalStringParser(number);

export const dateParser = (date?: string): string | undefined =>
  formatDate(date, "YYYY-MM-DD");

export const numericParser = (cc: string): string => cc.replace(/\D/g, "");
